import { render } from "./ModalAdministrar.vue?vue&type=template&id=e201139c&scoped=true"
import script from "./ModalAdministrar.vue?vue&type=script&lang=js"
export * from "./ModalAdministrar.vue?vue&type=script&lang=js"

import "./ModalAdministrar.vue?vue&type=style&index=0&id=e201139c&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e201139c"]])

export default __exports__